import React from 'react';
import {HeroMetadata, Metadata} from '../index';
import VideoModal from './videoModal';

const VideoContainer = props => (
    <div role="button" tabIndex="0" className={`${props.display} video-container`} onClick={() => props.openVideoModal(props.data, props.analyticsArgument)}>
        {/* TODO :: Replace with still and add alt tag */}
        <img src={`/images/baby.png`} className="article-img" alt="replace me" />
        <img src={`/images/play-btn.png`} alt="play button" className="play-btn"/>
        {props.isHero ?
            <HeroMetadata data={props.data} contentType={`video`} /> :
            <Metadata data={props.data} contentType={`video`} />
        }
        <VideoModal />
    </div>
);

VideoContainer.defaultProps = {isHero: false};

export default VideoContainer;
